<div class="padding">
  <mat-card class="mat-elevation-z0">
    <div
      *ngFor="
        let part of windowSticker.clientStickerParts;
        let i = index;
        let first = first;
        let count = count
      "
      [ngClass]="i > 0 ? 'upper-space' : ''"
    >
      <div class="form-title">
        <div class="d-flex justify-content-between">
          <div class="form-title-text align-title-text">
            Afmetingen sticker{{ count > 1 ? ' #' + (i + 1) : '' }}: standaard
            of op maat
          </div>
          <div
            *ngIf="count > 1"
            class="clickable"
            (click)="deleteStickerPart(index)"
          >
            <mat-icon svgIcon="close"></mat-icon>
          </div>
        </div>
      </div>
      <client-window-sticker-part-form
        [windowSticker]="windowSticker"
        [part]="part"
        [index]="i"
        [enableDelete]="enableDeleteStickerPart"
        [windowStickerSizeGetter]="windowStickerSizeGetter"
        (typeIsSelected)="handleTypeIsSelected(part)"
        (delete)="deleteStickerPart(i)"
      ></client-window-sticker-part-form>

      <div *ngIf="first" class="upper-space d-flex">
        <div>
          <div class="strong">Tijdelijk / Permanent</div>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="windowSticker.temporaryMaterial"
              (ngModelChange)="temporaryMaterialChanged()"
            >
              <mat-option [value]="true">Tijdelijk</mat-option>
              <mat-option [value]="false">Permanent</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          *ngIf="windowSticker.temporaryMaterial != null"
          class="small-left-space"
        >
          <div class="strong">Materiaal</div>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Materiaal"
              [(ngModel)]="windowSticker.foil"
              [compareWith]="compareMaterialOptions"
              (ngModelChange)="foilChanged()"
            >
              <ng-container *ngIf="windowSticker.temporaryMaterial === true">
                <mat-option
                  *ngFor="let option of temporaryMaterialOptions"
                  [value]="option.material"
                  >{{ option.label }}</mat-option
                >
              </ng-container>
              <ng-container *ngIf="windowSticker.temporaryMaterial === false">
                <mat-option
                  *ngFor="let option of permanentMaterialOptions"
                  [value]="option.material"
                  >{{ option.label }}</mat-option
                >
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          *ngIf="windowSticker.temporaryMaterial != null"
          class="small-left-space"
        >
          <div class="strong">Laminaat</div>
          <mat-form-field appearance="outline">
            <mat-select
              placeholder="Laminaat"
              [(ngModel)]="windowSticker.laminate"
              [compareWith]="compareMaterialOptions"
            >
              <ng-container *ngIf="windowSticker.temporaryMaterial === true">
                <mat-option
                  *ngFor="let option of temporaryLaminateOptions"
                  [value]="option.material"
                  >{{ option.label }}</mat-option
                >
              </ng-container>
              <ng-container *ngIf="windowSticker.temporaryMaterial === false">
                <mat-option
                  *ngFor="let option of permanentLaminateOptions"
                  [value]="option.material"
                  >{{ option.label }}</mat-option
                >
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-card>

  <div class="upper-space">
    <button
      class="button under-space"
      (click)="addStickerPart()"
      type="button"
      mat-button
      [disabled]="disableAddSticker"
    >
      + Extra sticker
    </button>
  </div>
</div>
